import React, { useState } from 'react';
import Router from '../router';
import { UserContext } from '../context/User';
import 'bootstrap-daterangepicker/daterangepicker.css';
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css';
import 'animate.css/animate.min.css';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState({});

  return (
    <UserContext.Provider value={{user, setUser, isLoggedIn, setIsLoggedIn}}>
      <div className="App">
        <ReactNotification />
        <Router />
      </div>
    </UserContext.Provider>
  );
}

export default App;